"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pendingIDsReducer = void 0;
const pendingIDs_1 = require("../actions/pendingIDs");
const initState = [];
const pendingIDsReducer = (pendingIds = initState, action) => {
    switch (action === null || action === void 0 ? void 0 : action.type) {
        case pendingIDs_1.ADD_PENDING_ID:
            return [...pendingIds, action.payload];
        case pendingIDs_1.REMOVE_PENDING_ID:
            return pendingIds.filter((item) => item !== action.payload);
        default:
            return pendingIds;
    }
};
exports.pendingIDsReducer = pendingIDsReducer;
//# sourceMappingURL=pendingIDs.reducer.js.map